// NotFound.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../../components/Layout/PageShell';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/NotFound/partnerBrandsData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/NotFound/scrollingCardsData.json';

import SectionStepsComponent from '../../components/HomePage/SectionSteps/SectionGreyStepsComponent';
import SectionStepsMobileComponent from '../../components/HomePage/SectionSteps/SectionStepsGreyMobileComponent';
import sectionStepsData from '../../json/components/HomePages/NotFound/sectionStepsData.json';

import FooterComponent from '../../components/HomePage/Footer/FooterComponent';
import FooterMobileComponent from '../../components/HomePage/Footer/FooterMobileComponent';
import ScrollFadeWrapper from '../../components/ScrollFadeWrapper/ScrollFadeWrapper';

// 404 Image
const NOT_FOUND_IMAGE = 'https://assets.askhippo.co.za/Pages/NotFound/404.svg';

const NotFound = () => {
  const isMobile = useMobileContext();
  const isDesktop = Boolean(isMobile.isDesktop);

  return (
    <>
      <Helmet>
        <title>Page Not Found | Hippo</title>
        <meta name="robots" content="NOINDEX, NOFOLLOW" />
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          py: isMobile ? 1 : 4,
          minHeight: isMobile ? '100vh' : 'auto',
          overflowX: 'clip',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: '#F3F6F6',
            zIndex: 0,
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
            {/* 404 Image */}
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                component="img"
                src={NOT_FOUND_IMAGE}
                alt="404 Not Found"
                sx={{
                  width: isDesktop ? '976px' : '100%',
                  maxWidth: isDesktop ? '976px' : '520px',
                  height: 'auto',
                }}
              />
            </Box>

            {/* Steps Section */}
            <ScrollFadeWrapper>
              {isDesktop ? (
                <SectionStepsComponent data={sectionStepsData} />
              ) : (
                <SectionStepsMobileComponent data={sectionStepsData} />
              )}
            </ScrollFadeWrapper>

            <ScrollFadeWrapper>
              {isDesktop ? (
                <ScrollingCardsComponent data={scrollingCardsData} />
              ) : (
                <ScrollingCardsMobileComponent data={scrollingCardsData} />
              )}
            </ScrollFadeWrapper>

            {/* Partner Brands */}
            <ScrollFadeWrapper>
              {isDesktop ? (
                <PartnerBrandsComponent data={partnerBrandsData} />
              ) : (
                <PartnerBrandsMobileComponent data={partnerBrandsData} />
              )}
            </ScrollFadeWrapper>
          </PageShell>

          {/* Footer */}
          {isDesktop ? <FooterComponent /> : <FooterMobileComponent />}
        </Box>
      </Box>
    </>
  );
};

export default NotFound;
